export const PLUGIN_PREFIX = 'madden-plugin';
export const PLUGIN_SETTNGS_SLUG = 'plugin:madden_plugin';